import dayjs from 'dayjs'
import { useState } from 'react'

export const computeDeltaTimestampsFromReference = (referenceTimestamp: number): [number, number, number] => {
  const referenceTime = dayjs.unix(referenceTimestamp)
  const t1 = referenceTime.subtract(1, 'day').startOf('minute').unix()
  const t2 = referenceTime.subtract(2, 'day').startOf('minute').unix()
  const tWeek = referenceTime.subtract(1, 'week').startOf('minute').unix()
  return [t1, t2, tWeek]
}

export const computeDeltaTimestamps = (): [number, number, number] => {
  return computeDeltaTimestampsFromReference(dayjs().unix())
}

let cachedTimestamps: [number, number, number] | undefined

export const getCachedDeltaTimestamps = (): [number, number, number] => {
  if (!cachedTimestamps) {
    cachedTimestamps = computeDeltaTimestamps()
  }

  return cachedTimestamps
}

export const resetCachedDeltaTimestamps = () => {
  cachedTimestamps = undefined
}

export function useDeltaTimestamps(): [number, number, number] {
  const [timestamps] = useState(getCachedDeltaTimestamps)
  return timestamps
}
